import Back from '../Back';
import Content from '../Content';
import Properties from '../Properties';
import createPropertyRecord from '../helpers/createPropertyRecord';
import useDevTools from '../hooks/useDevTools';
import { useSelector } from 'react-redux';

const AppProperties = () => {
  const { setMenu } = useDevTools();

  const rendering = useSelector((state) => {
    const slice = state.properties.light;
    const slicePaint = state.properties.paint;

    const toReturn = [
      createPropertyRecord('properties.light.diffuseScale', 'diffuseScale', slice.diffuseScale),
      createPropertyRecord('properties.light.minimalNormalScale', 'minimalNormalScale', slice.minimalNormalScale),
      {
        id: 'properties.light.eyeDirection',
        name: 'eyeDirection',
        value: slice.eyeDirection,
        readonly: false,
        regular: false,
      },
      {
        id: 'properties.light.lightDirection',
        name: 'lightDirection',
        value: slice.lightDirection,
        readonly: false,
        regular: false,
      },
    ];

    const keys = Object.keys(slicePaint);

    return [...toReturn, ...keys.map((key) => createPropertyRecord(`properties.paint.${key}`, key, slicePaint[key]))];
  });

  const textures = useSelector((state) => {
    return [
      {
        ...createPropertyRecord('testing.testedTexture', 'textureName', state.testing.testedTexture, 'string'),
        undefinedText: 'default',
      },
    ];
  });

  const ui = useSelector((state) => {
    return [createPropertyRecord('properties.ui.showBrush', 'showBrush', state.properties.ui.showBrush, 'boolean')];
  });

  const global = useSelector((state) => {
    return [
      createPropertyRecord('properties.global.alpha', 'alpha', state.properties.global.alpha, 'float'),
      createPropertyRecord('properties.global.useGlobalAlpha', 'useGlobalAlpha', state.properties.global.useGlobalAlpha, 'boolean'),
    ];
  });

  const currentLayer = useSelector((state) => {
    return [createPropertyRecord('properties.currentLayer.showPencil', 'showPencil', state.properties.currentLayer.showPencil, 'boolean')];
  });

  return (
    <>
      <Back title="App properties" />

      <Content>
        <Properties
          index={0}
          data={global}
          title="Globals"
          regularChange={(obj) => {
            setMenu(1, 'edit-property', { ...obj, menuIndex: 1 });
          }}
        />

        <Properties
          index={0}
          data={textures}
          title="Output texture"
          regularChange={() => {
            setMenu(1, 'edit-tested-texture', {
              menuIndex: 1,
              name: 'textureName',
            });
          }}
        />

        <Properties
          index={0}
          data={currentLayer}
          title="Current layer"
          regularChange={(obj) => {
            setMenu(1, 'edit-property', { ...obj, menuIndex: 1 });
          }}
        />

        <Properties
          index={0}
          data={rendering}
          title="Render parameters"
          regularChange={(obj) => {
            setMenu(1, 'edit-property', { ...obj, menuIndex: 1 });
          }}
          extraChange={(obj) => {
            setMenu(1, 'edit-rotation', { ...obj, menuIndex: 1 });
          }}
        />

        <Properties
          index={0}
          data={ui}
          title="User interface"
          regularChange={(obj) => {
            setMenu(1, 'edit-property', { ...obj, menuIndex: 1 });
          }}
        />
      </Content>
    </>
  );
};

export default AppProperties;
